/**
 * FIDO2 相關常數
 */

export const FIDO_TERMS = {
  TITLE: {
    id: 'SH_Fido_TermsTitle',
    defaultMessage: 'FIDO 零密碼通行使用條款',
  },
  CONTENT: [
    {
      id: 'SH_Fido_Web_Policy1',
      defaultMessage:
        '鼎恒數位科技股份有限公司Apollo人資系統零密碼通行(FIDO)服務條款',
    },
    {
      id: 'SH_Fido_Web_Policy1-1',
      defaultMessage:
        '一、 名詞解釋\n1.FIDO(Fast Identity Online，FIDO)：係指採用國際組織FIDO 聯盟所建立之國際級標準，以非對稱金鑰技術為基礎之技術，提升快速登入與交易安全性之驗證方式。\n2.指紋辨識：係指客戶利用行動裝置內建之指紋辨識功能於Apollo人資系統上進行身分確認。\n3.Face ID：係指客戶利用美國蘋果公司授權生產之行動裝置內建的Face ID功能以人臉辨識技術於Apollo人資系統上進行身分確認。',
    },
    {
      id: 'SH_Fido_Policy2',
      defaultMessage:
        '二、本服務內容\n1.Apollo人資系統零密碼通行(FIDO)服務(下稱「本服務」)，係指您於您指定的行動裝置完成本服務的綁定後，您即能透過FIDO驗證方式，即行動裝置內建的裝置密碼/指紋辨識/Face ID 功能於Apollo人資系統執行包含但不限於登入、上下班打卡、查詢薪資等服務。\n2.當您於您的行動裝置完成本服務設定及綁定，並開始執行登入、上下班打卡、查詢薪資資料等行為，即表示您知悉並同意本服務約定之全部內容。凡透過本服務驗證確認身分後所為之行為，均視為您本人親自執行之行為。',
    },
    {
      id: 'SH_Fido_Policy3',
      defaultMessage:
        '三、本服務的限制\n1.本服務需利用指紋辨識/Face ID功能，故僅限具有內建指紋辨識/Face ID功能的行動裝置使用。\n2.每台行動裝置僅接受一位客戶綁定本服務，因此您僅得綁定暨開通一台行動裝置。\n3.當您透過本服務驗證及登入Apollo人資系統，如登入錯誤次數累計 3 次，系統即自動切換為原設定的帳號和密碼。\n4.FIDO驗證技術目前僅支援 iOS 10 以上版本與 Android7.0 以上版本，如您的行動裝置之版本不符以上版本，則無法使用本服務。\n5.如您欲註銷本服務或您不再使用所約定之行動裝置，請重新登入Apollo人資系統，點選[我的設定]後點選[FIDO註銷]。\n6.本服務免費試用至2025年12月31日止。',
    },
    {
      id: 'SH_Fido_Policy4',
      defaultMessage:
        '四、您應負責的義務\n1.本服務之一切權利為本公司或權利人所有，您不得對本服務進行還原工程、解編、反向組譯或其他規避科技保護措施之方式不當使用或將本服務複製至其他裝置。\n2.您應妥善保管使用已註冊的行動裝置，如您將該行動裝置出借、轉讓或質押予他人者，您應自負相關責任。如您的行動裝置有遺失、被竊或其他喪失占有等情形時，您應儘速將已註冊裝置進行註銷手續或通知本公司客服。如您未辦理前述手續前而遭冒用，您將自行負擔法律上之風險。',
    },
    {
      id: 'SH_Fido_Policy5',
      defaultMessage:
        '五、個人資料之保護\n您了解並同意本公司得於本服務合理及必要之範圍內蒐集、處理及利用您的個人資料(包含但不限於裝置資訊、IP位置)，有關個人資料保護事宜，請參考本公司隱私權政策條款。惟，本公司不會留存您的生物特徵資訊，如欲深入瞭解生物辨識技術請詳閱您的行動裝置原廠說明。',
    },
    {
      id: 'SH_Fido_Policy6',
      defaultMessage:
        '六、 準據法及管轄法院\n本約定條款之解釋與適用，以中華民國法律為準據法。因本服務所生之任何爭議及糾紛雙方同意以協商方式解決，如未能解決者，雙方同意以臺灣臺北地方法院為第一審管轄法院。',
    },
  ],
};

export const FIDO_MESSAGES = {
  REGISTRATION_SUCCESS: 'SH_Fido_RegisterSuccess',
  REGISTRATION_FAILED: 'SH_Fido_RegisterFail',
  REGISTRATION_IN_PROGRESS: 'FIDO2 註冊進行中...',
};

export const FIDO_ERRORS = {
  ENVIRONMENT_CHECK_FAILED: '環境檢查失敗',
  CREDENTIAL_CREATION_FAILED: '憑證創建失敗',
  REGISTRATION_API_FAILED: '註冊 API 失敗',
};

export const FIDO_RESULT_STATUS = {
  0: 'success',
  1: 'fail',
};

export const FIDO_RESULT_MESSAGES_ID = {
  // success: '註冊成功！FIDO 零密碼通行已啟用',
  success: 'SH_Fido_PassEnabled',
  fail: 'SH_Fido_RegisterFail',
};

export const FIDO_RESULT_TITLE_ID = {
  success: 'SH_Fido_RegisterSuccess',
  fail: 'SH_Fido_RegisterFail',
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/constant/fido.js
 **/